import React, { useState } from "react"
import animateSections from "./animationSections"
import { defPath, fetchPath } from '../../config/defPath'
// @ts-ignore
import * as Bouncer from 'formbouncerjs'

function validateNewPasswordForm() {
  const bouncer = new Bouncer('#new', {
    customValidations: {
      password: (field: any) => {
        if (field.name == 'new_password') {
          const value = field.value

          if (value.length < 8) {
            return true;
          }
        }
      },

      confirmPass: (field: any) => {
        if (field.name == 'new_password_confirm') {
          const password = document.querySelector('#new_password') as any
          const value = field.value

          if (password.value != value) {
            return true;
          }
        }
      },
    },

    messages: {
      missingValue: {
        default: 'Este campo es obligatorio',
        select: 'Este campo es obligatorio',
        checkbox: 'Este campo es obligatorio',
      },
      password: 'Debe contener mínimo 8 caracteres',
      confirmPass: 'Las contraseñas no coinciden',
      patternMismatch: {
        email: 'Ingresa un correo válido',
      },
    },
    disableSubmit: true
  })
}

window.dataLayer = window.dataLayer || [];

export default function ValidateToken() {

  async function submitNew(form: any) {
    const formData: any = new FormData(form)
    let locationPass = localStorage.getItem('locationPass')
    let uid = locationPass?.split('&')[0].split('=')[1]
    let token = locationPass?.split('&')[1].split('=')[1]
    formData.append('uid', uid)
    formData.append('token', token)

    const temp = Object.fromEntries(formData)

    let url = `${fetchPath}/aguila/loyalty/validate/token`

    try {
      let res = await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(temp)
      })
      const data = await res.json();

      validateRequestNew(data, form, res.status)
    }

    catch (error) {
      console.log("error", error)
    }
  }

  const error = document.createElement('div')
  const validateRequestNew = (data: any, form: HTMLElement, res: any) => {
    error.classList.add('error-drupal')

    if (res == 200) {
      animateSections('#sectionNew', '#sectionUpdate')
      localStorage.removeItem('locationPass')

      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Content',
        'event_label': 'Password Updated Successfully',
        'interaction': 'true',
        'component_name': 'Password Recovery',
        'element_text': 'Contraseña actualizada',
      });
    }

    else if (data.message == 'Las contraseñas no son iguales.') {
      error.innerHTML = data.message
      form.appendChild(error)
    }

    else {
      animateSections('#sectionNew', '#sectionError')
      localStorage.removeItem('locationPass')

      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Content',
        'event_label': 'Password Updated Error',
        'interaction': 'true',
        'component_name': 'Password Recovery',
        'element_text': 'Contraseña actualizada error',
      });
    }
  }

  const validateURL = () => {
    if (location.search.includes('uid') && location.search.includes('token')) {
      // animateSections('#sectionRegister', '#sectionNew')
      localStorage.setItem('locationPass', location.search)
    } else {
      location.href = '/estadio-aguila'
    }
  }

  React.useEffect(() => {
    validateURL()
    validateNewPasswordForm()

    document.addEventListener('bouncerFormValid', function (event: any) {
      let id = event.target.getAttribute('id')

      if (id == 'new') {
        submitNew(event.target)
      }
    }, false);
  }, [])



  return (
    <>
      <NewPassword />
      <UpdatePasswordSuccess />
      <ErrorNewPassword />
    </>
  )
}

function NewPassword() {

  const [showPass, setshowPass] = useState(false)

  const handleShowPass = () => {
    setshowPass(prevState => !prevState)
  }

  function handleClick() {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Send New Password',
      'interaction': 'true',
      'component_name': 'Password Recovery',
      'element_text': 'Enviar',
    });
  }

  return (
    <div className="ar__new ar__content__section" id="sectionNew">
      <div className="ar__content__title">
        <h2 className="ar__login__title title_2 whiteShadow"><span>nueva</span> contraseña</h2>
      </div>

      <form method="post" id="new" className="ar__new__form">
        <div className="row">
          <div className="passwordBox">
            <input required type={`${showPass ? 'text' : 'password'}`} name="new_password" placeholder="Ingresa tu nueva contraseña" id="new_password" />
            <label htmlFor="new_password" className="black_30 whiteShadow">nueva contraseña</label>
            <div className="eye" onClick={handleShowPass}></div>
          </div>
        </div>
        <div className="row">
          <div className="passwordBox">
            <input required type={`${showPass ? 'text' : 'password'}`} name="new_password_confirm" placeholder="Repite tu contraseña" />
            <label htmlFor="new_password_confirm" className="black_30 whiteShadow">confirmar Contraseña</label>
            <div className="eye" onClick={handleShowPass}></div>
          </div>
        </div>

        <button type="submit" className="ar__btn ar__btn-primary" onClick={handleClick}>Enviar</button>
      </form>
    </div>

  )
}
function UpdatePasswordSuccess() {

  function handleGoHome() {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Password Updated Successfully',
      'interaction': 'true',
      'component_name': 'Password Recovery',
      'element_text': 'Ir al home',
    });
    location.href = '/estadio-aguila/iniciar-sesion'
  }

  return (
    <div className="ar__update ar__content__section ar__close" id="sectionUpdate">
      <div className="ar__content__title">
        <h2 className="ar__login__title title_2 whiteShadow"><span>Contraseña</span> actualizada</h2>
      </div>

      <img className="ar__icon-status" src={`${defPath}/assets/images/icons/icon_circle_done.svg`} />

      <p className="ar__thank__text medium_30 whiteShadow">Hemos actualizado tu contraseña exitosamente. Inicia sesión, explora y consigue muchos premios.</p>

      <button className="ar__btn ar__btn-primary" onClick={handleGoHome}>Ir al home</button>
    </div>
  )
}

function ErrorNewPassword() {

  function handleErrorBtn() {
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Password Updated Error',
      'interaction': 'true',
      'component_name': 'Password Recovery',
      'element_text': 'Volver',
    });

    animateSections('#sectionError', '#sectionNew')

  }

  return (
    <div className="ar__error ar__content__section ar__close" id="sectionError">
      <div className="ar__content__title">
        <h2 className="ar__login__title title_2 whiteShadow"><span>Algo</span> salio mal</h2>
      </div>

      <img className="ar__icon-status" src={`${defPath}/assets/images/icons/icon_circle_error.svg`} />

      <p className="ar__error__text medium_30 whiteShadow">Ha ocurrido un error interno, por favor intentalo de nuevo.</p>

      <button className="ar__btn ar__btn-primary" onClick={handleErrorBtn}>Volver</button>
    </div>
  )
}